class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        this.close();
      }
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code?.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote = this.querySelector(
      '[id^="Details-"] summary'
    );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        if (
          containerToTrapFocusOn &&
          focusElement &&
          typeof trapFocus === 'function'
        ) {
          trapFocus(
            containerToTrapFocusOn,
            focusElement
          );
        }
      },
      { once: true }
    );

    document.body.classList.add(
      'overflow-hidden'
    );
  }

  close() {
    this.classList.remove('active');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }

    document.body.classList.remove(
      'overflow-hidden'
    );
  }

  setSummaryAccessibility(cartDrawerNote) {
    if (!cartDrawerNote) return;

    cartDrawerNote.setAttribute(
      'role',
      'button'
    );

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    const nextElement =
      cartDrawerNote.nextElementSibling;

    if (nextElement?.id) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        nextElement.id
      );
    }

    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget
            .closest('details')
            .hasAttribute('open')
        );
      }
    );

    if (
      cartDrawerNote.parentElement &&
      typeof onKeyUpEscape === 'function'
    ) {
      cartDrawerNote.parentElement.addEventListener(
        'keyup',
        onKeyUpEscape
      );
    }
  }

  renderContents(parsedState) {
    const drawerInner =
      this.querySelector('.drawer__inner');

    if (
      drawerInner?.classList.contains(
        'is-empty'
      )
    ) {
      drawerInner.classList.remove(
        'is-empty'
      );
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach(
      (section) => {
        const sectionElement =
          section.selector
            ? document.querySelector(
                section.selector
              )
            : document.getElementById(
                section.id
              );

        if (
          sectionElement &&
          parsedState.sections?.[
            section.id
          ]
        ) {
          sectionElement.innerHTML =
            this.getSectionInnerHTML(
              parsedState.sections[
                section.id
              ],
              section.selector
            );
        }
      }
    );

    setTimeout(() => {
      const overlay =
        this.querySelector(
          '#CartDrawer-Overlay'
        );

      if (overlay) {
        overlay.addEventListener(
          'click',
          this.close.bind(this)
        );
      }

      this.open();
    });
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const element =
      parsedHTML.querySelector(
        selector
      );

    return element
      ? element.innerHTML
      : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

if (
  !customElements.get(
    'cart-drawer-items'
  )
) {
  customElements.define(
    'cart-drawer-items',
    CartDrawerItems
  );
}
document.addEventListener(
  'click',
  (event) => {
    const closeButton =
      event.target.closest(
        '.js-cart-drawer-close'
      );

    if (!closeButton) return;

    const cartDrawer =
      closeButton.closest(
        'cart-drawer'
      );

    if (cartDrawer?.close) {
      cartDrawer.close();
    }
  }
);